var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.is_onvego)?_c('w-textarea',_vm._g(_vm._b({},'w-textarea',_vm.$attrs,false),_vm.$listeners)):(_vm.has_onvego_apointments)?_c('div',{ref:"onvego_iframe_container",attrs:{"id":_vm.onvego_iframe_container_id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }